function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 24.15,
  y1: 325.85,
  x2: 162.7,
  y2: 513.8,
  fill: "none",
  stroke: "#e5daca",
  strokeMiterlimit: 10,
  strokeWidth: 60
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 421.74,
  y1: 13.8,
  x2: 162.7,
  y2: 513.8,
  fill: "none",
  stroke: "#e5daca",
  strokeMiterlimit: 10,
  strokeWidth: 60
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M429,673.29l2.72,3.69,7.37,10,10.94,14.84,13.36,18.12L478,739.68l14.77,20,13.77,18.68,11.59,15.72,8.38,11.37c1.32,1.79,2.64,3.59,4,5.38l.17.24a28.92,28.92,0,0,0,29.89,14.32,22.32,22.32,0,0,0,11.15-3.56l6.08-4.69a30,30,0,0,0,7.71-13.24l1.07-8a29.84,29.84,0,0,0-4.09-15.14l-2.73-3.69-7.36-10L561.4,752.29,548,734.17l-14.56-19.74-14.77-20L504.94,675.7,493.35,660,485,648.62l-4-5.39c-.06-.07-.11-.15-.17-.23a22.67,22.67,0,0,0-7.73-8.41,22.41,22.41,0,0,0-10.2-5.37,22.75,22.75,0,0,0-12-.54,22.39,22.39,0,0,0-11.16,3.56l-6.07,4.69A29.89,29.89,0,0,0,426,650.17l-1.07,8A29.85,29.85,0,0,0,429,673.29Z",
  transform: "translate(-393.56 -282.16)",
  fill: "#e5daca"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M717.16,420.76l-5,9.63-13.57,26.2-20.08,38.75L654,542.62,627.2,594.4l-27.08,52.28-25.26,48.74L553.53,736.6l-15.34,29.61q-3.63,7-7.26,14l-.31.59A22.36,22.36,0,0,0,527.06,792a30.81,30.81,0,0,0,14.32,29.89c7,3.68,15.4,5.52,23.12,3,7.22-2.34,14.33-6.84,17.93-13.78l5-9.63L601,775.28l20.07-38.75,24.5-47.28,26.82-51.78,27.09-52.28,25.25-48.74,21.34-41.18,15.34-29.61c2.42-4.68,4.85-9.34,7.26-14l.3-.59a22.26,22.26,0,0,0,3.56-11.16,26.9,26.9,0,0,0-5.9-22.16A22.7,22.7,0,0,0,758.2,410c-7-3.68-15.4-5.52-23.12-3-7.22,2.34-14.33,6.84-17.92,13.78Z",
  transform: "translate(-393.56 -282.16)",
  fill: "#e5daca"
});

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448.38 543.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.0607952b.svg";
export { ForwardRef as ReactComponent };